module.exports = __webpack_public_path__ + "static/media/instagram.c8a77e4d.png";